import { render, staticRenderFns } from "./LoaLab.vue?vue&type=template&id=bf68ce8a&scoped=true&"
import script from "./LoaLab.vue?vue&type=script&lang=js&"
export * from "./LoaLab.vue?vue&type=script&lang=js&"
import style0 from "./LoaLab.vue?vue&type=style&index=0&id=bf68ce8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf68ce8a",
  null
  
)

export default component.exports